export default __webpack_public_path__ + "static/media/icon_finishingtype_Grooved.e8215e9d.png";